export const baseUrl = 'https://galupi-backend-0621c137a6c0.herokuapp.com/api/me';
export const stripePublicKey = 'pk_live_51MCFohBLAwOv1xkS878lqRBtyCt67TnCfb5tzvchrFz1qG91gNiPymu8aKelFsm5gkWc4e5i7pBAri44MkkGQ1ai00QtMboUD0';
